<template>
  <div class="parent">
    <z-nav/>
    <h1 class="error">Consultation has been closed</h1>
    <img src="@/assets/thank-you.svg">
    <br/>
    <br/>

    <h3>Thank you for your interest in co-creating policy with us. </h3>
    <p class="container"> 

We are currently reviewing feedback and will update the document soon.

If you have any comments on the NIIEV, please email us at, <a href="mailto:info@ictinnovation.gov.ng">info@ictinnovation.gov.ng</a></p>
  </div>
</template>

<script>

  import ZNav from "../components/nav";

  export default {
    name: "thank-you",
    components: {
      ZNav
    }
  };
</script>

<style scoped>

  img {
    width: 100%;
    max-width: 600px;
  }

  .error {
    color: #960000;
  }
</style>
